// Mêmes domaines que ceux acceptés côté serveur (server/src/services/playlistUrl.ts,
// qui reste l'autorité : ce test n'est là que pour aiguiller la saisie).
const PLAYLIST_HOSTS: ReadonlySet<string> = new Set([
	'youtube.com',
	'www.youtube.com',
	'm.youtube.com',
	'music.youtube.com',
]);

/**
 * Indique si un texte saisi est un lien de playlist YouTube
 * (`youtube.com/playlist?list=...`), par opposition à un lien de vidéo.
 *
 * Sert uniquement à choisir entre « parcourir la playlist » et « ajouter la
 * vidéo » : la validation stricte reste côté serveur. Un lien de vidéo
 * portant un paramètre `list` (`watch?v=...&list=...`) n'est volontairement
 * pas une playlist - il désigne une vidéo, comme côté serveur.
 *
 * @param input - Texte saisi par l'utilisateur.
 * @returns `true` si `input` ressemble à un lien de playlist YouTube.
 */
export function isPlaylistUrl(input: string): boolean {
	let url: URL;
	try {
		url = new URL(input.trim());
	} catch {
		return false;
	}

	return (
		url.protocol === 'https:' &&
		PLAYLIST_HOSTS.has(url.hostname) &&
		url.pathname === '/playlist' &&
		(url.searchParams.get('list') ?? '') !== ''
	);
}
